import { render, staticRenderFns } from "./myPortfolio.vue?vue&type=template&id=45b55147&scoped=true&"
import script from "./myPortfolio.vue?vue&type=script&lang=js&"
export * from "./myPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./myPortfolio.vue?vue&type=style&index=0&id=45b55147&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b55147",
  null
  
)

export default component.exports